// src/DataDogBrowserLogsTransport.ts
import { BaseTransport, LogLevel } from "@loglayer/transport";
var DataDogBrowserLogsTransport = class extends BaseTransport {
  shipToLogger({ logLevel, messages, data, hasData }) {
    const toPublish = [];
    toPublish.push(messages.join(" "));
    if (data && hasData) {
      toPublish.push(data);
    }
    switch (logLevel) {
      case LogLevel.info:
        this.logger.info(...toPublish);
        break;
      case LogLevel.warn:
        this.logger.warn(...toPublish);
        break;
      case LogLevel.error:
        this.logger.error(...toPublish);
        break;
      case LogLevel.trace:
        this.logger.debug(...toPublish);
        break;
      case LogLevel.debug:
        this.logger.debug(...toPublish);
        break;
      case LogLevel.fatal:
        this.logger.error(...toPublish);
        break;
    }
    return toPublish;
  }
};
export {
  DataDogBrowserLogsTransport
};
